import {
  IntervalUnit,
  type DelayActionData,
  type DelayDuration,
} from '@/proto/logiblocks/logiblocks';

/**
 * Default delay duration: 30 minutes. Used as a fallback when the node is in
 * a non-duration mode and the user switches into DURATION.
 */
export const DEFAULT_DELAY_DURATION: DelayDuration = {
  seconds: 1800,
  display_unit: IntervalUnit.MINUTES,
};

/**
 * Default delay action data: 30 minutes.
 */
export const DEFAULT_DELAY_ACTION: DelayActionData = {
  duration: DEFAULT_DELAY_DURATION,
};
